export function digitsOnly(value: string) {
  return value.replace(/\D/g, '')
}

export function formatPhoneNumber(phone: string) {
  let digits = digitsOnly(phone)
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1)
  }
  if (digits.length !== 10) return phone

  return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}
